import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { AbstractPage } from  '../../../_com/abstract-page';
import { ReserveAction } from '../../../../actions/reserve.action';
import { CompReserveListState } from '../../../../states/comp-reserve-list-state';
import { ConstantsStore } from '../../../../stores/constants-store';
import { HttpReserveProvider } from '../../../../providers/http-reserve';
import _ from 'underscore';
import Utils from '../../../../_com/utils';

/**
 * Generated class for the ReserveListAgePage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-reserve-list-age',
  templateUrl: 'reserve-list-age.html',
})
export class ReserveListAgePage extends AbstractPage {

  data = []; //描画データ

  onChangeDate = null; //描画日付 EventEmitter格納
  onSaveReserve = null; //予約変更 EventEmitter格納

  options: Object; //チャートオプション
  context: any; //チャートコンテキスト
  business_hours:number[];

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private reserveAction:ReserveAction,
    private compReserveListState:CompReserveListState,
    private constantsStore:ConstantsStore,
    private httpReserveProvider:HttpReserveProvider,
      ) {
    super();

    //チャートオプション構築
    this.buildChartOption();

    //初期検索
    this.refresh();

    /**
     * 表示日付切り替えイベント
     */
    this.onChangeDate = this.compReserveListState.onChangeDate.subscribe((data)=>{
      this.refresh();
    });

    /**
     * 予約情報更新イベント
     */
    this.onSaveReserve = this.httpReserveProvider.onSaveReserve.subscribe((data)=>{
      this.refresh();
    });
  }

  /**
   * チャートオプション構築
   */
  buildChartOption(){

    var dataToChart = new DataToChart();

    var bh = this.constantsStore.data["business_hours"];
    this.business_hours = dataToChart.buildTargetTimeTable(bh, DataToChart.TIME_TABLE_TYPE.HHMM_STRING);

    var defaultZero = [];
    for(var i=0 ;i<this.business_hours.length; i++){
      defaultZero.push(0);
    }

    this.options = {
      chart:{type: 'bar'},
      title:{text: false},
      credits:{enabled:false},
      xAxis: {categories: this.business_hours},
      yAxis: {
        min: 0,
        // max: 10,
        title: {text: false},
        tickInterval:2,
        stackLabels: {
          enabled: true,
          style: {
            fontWeight: 'bold',
            color: 'orange'
          }
        }
      },
      legend: {
        align: 'center',
        verticalAlign: 'top',
        reversed: true,
      },
      plotOptions: {
        series: {
          stacking: 'normal',
          dataLabels: {enabled: true, color: 'gray', borderWidth:0}
        },
        // column: {
        //   // stacking: 'normal',
        //   dataLabels: {enabled: true, color: 'blue'}
        // }
      },
      series: [
        {name: '3歳児以上', data: defaultZero.concat()}, 
        {name: '1・2歳児', data: defaultZero.concat()}, 
        {name: '0歳児', data: defaultZero.concat()}
      ],
      colors : ['#bfdfb9', '#FFDE94', '#F9ABA0', '#BBCAD8', '#faebd7', '#ffb6c1', '#f0e68c']
    };
  }

  /**
   * チャートコンテキスト
   */
  chartContext(_context){
    this.context = _context;
  }

  /**
   * 一覧データ取得
   */
  refresh(){

    this.reserveAction.getList({date:this.compReserveListState.date, isValidOnly:true}).subscribe((res)=>{
      this.data = res.data;

      var dataToChart = new DataToChart();
      var mapedData = dataToChart.mappingReserveData(this.data, this.constantsStore.data["business_hours"]);

      if(this.context){
        this.context.series[0].setData(mapedData[0]); 
        this.context.series[1].setData(mapedData[1]); 
        this.context.series[2].setData(mapedData[2]); 
      }
    });
  }

  /**
   * コンポーネント離脱
   */
  ngOnDestroy(){
    this.onChangeDate.unsubscribe();
    this.onSaveReserve.unsubscribe();
  }
}

/**
 * チャート用データ構築
 */
export class DataToChart{

  public static TIME_TABLE_TYPE = {
    HHMM_STRING : 0,
    HHMM_FULL_ZERO_STRING : 1
  }

  /**
   * タイムテーブル構築
   */
  buildTargetTimeTable(business_hours:{from: number, to: number}, type:number):any{

    var res = [];

    for(var i=business_hours.from; i<=business_hours.to; i=i+0.5){
      
      switch(type){
        case DataToChart.TIME_TABLE_TYPE.HHMM_STRING:
          res.push(Math.floor(i/1) + ":" + ('0' + (i%1 * 60)).slice(-2));
          break;
        case DataToChart.TIME_TABLE_TYPE.HHMM_FULL_ZERO_STRING:
          res.push(("0" + Math.floor(i/1)).slice(-2) + ":" + ('0' + (i%1 * 60)).slice(-2));
          break;
      }
    }
    return res;
  }

  /**
   * 予約データをseriesデータにセットする
   */
  mappingReserveData(data, businnes_hours:{from: number, to: number}):any{

    var bhs = this.buildTargetTimeTable(businnes_hours, DataToChart.TIME_TABLE_TYPE.HHMM_FULL_ZERO_STRING);

    var defaultZero = [];
    for(var i=0; i<bhs.length; i++){
      defaultZero.push(0);
    }
    var res = [Utils.clone(defaultZero), Utils.clone(defaultZero), Utils.clone(defaultZero)];

     _.each(data, (d)=>{

        var rtime = d["Reserve"]["datetime"]["time"];
        var children = d["Reserve"]["children"];

        _.each(bhs, (bh, index)=>{
          if((index + 1) < bhs.length){
            var from = bh;
            var to = bhs[index + 1]

            //対象時間判定
            if(((from <= rtime[0]) && (rtime[0] < to)) ||  //開始時間近辺
               ((from >= rtime[0]) && (to <= rtime[1])) || //中間時間
               ((to >= rtime[1]) && (rtime[1] > from))){ //終了時間近辺

              //月齢別割り振り
              _.each(children, (child)=>{
                if(parseInt(child["childOfAge"][0]) == 0){
                  res[2][index]++;
                } else if(child["childOfAge"][0] <= 2){
                  res[1][index]++;
                } else {
                  res[0][index]++;
                }
              });
            }
          }
        });
      });

    return res;
  }
}


// WEBPACK FOOTER //
// ./src/pages/reserve/list/age/reserve-list-age.ts